import React from 'react';

import './MobileWarning.css';
import ncLogoWhite from '../svg/nc-logo-beige.svg';

function MobileWarning(props: {}) {
  return (
    <div className="mobile-warning">
      <div className="mobile-warning__head">
        <img src={ncLogoWhite} className="mobile-warning__logo" alt="Neon Coat Logo" />
      </div>

      <div className="mobile-warning__content">
        <img
          className="mobile-warning__computer"
          src="/img/desktop.png"
          srcSet="/img/desktop@2x.png 2x,/img/desktop@3x.png 3x"
          alt="Desktop"
        />
        <h1 className="mobile-warning__title">OPEN ON A DESKTOP</h1>
        <span className="mobile-warning__subtitle">
          This Organic Results experience is optimized to be viewed on a computer
        </span>
        <span className="mobile-warning__instagram">
          For continuous updates, check out the{' '}
          <img
            src="/img/ig.png"
            srcSet="/img/ig@2x.png 2x,/img/ig@3x.png 3x"
            alt="Instgram Action"
          />
          Instagram Action section of your Neon Coat for Brands app.
        </span>

        <a className="nc-btn" href="neoncoat.business://instagram">
          Open Neon Coat
        </a>
      </div>
    </div>
  );
}

export default MobileWarning;
